import React, { useContext, createContext } from "react";
import { useKeycloak } from "@react-keycloak/web";

// Create a user context
const userContext = createContext();

/**
 * Returns user context provider to child elements
 * @param {Child elements of the provider} children
 */
export function ProvideUser({ children }) {
	const { keycloak } = useKeycloak();
	let user = useProvideUser({ keycloak });

	return <userContext.Provider value={user}>{children}</userContext.Provider>;
}

/**
 * Returns hook for user context
 */
export const useUser = () => useContext(userContext);

/**
 * Returns user object from Keycloak
 * @param {User object from Keycloak} keycloakObj
 */
const useProvideUser = (keycloakObj) => {
	const tokenParsed = keycloakObj.keycloak.tokenParsed;
	const token = keycloakObj.keycloak.token;

	const tokenIsDefined = typeof tokenParsed !== "undefined";
	return tokenIsDefined ? { ...tokenParsed, token } : null;
};

/**
 * Get default password for new users
 * @param {string} country
 * @returns Default password of new users
 */
 export const getPassword = (country) => {
  const lowercaseCountry = country.toLowerCase();

  return `Gy${lowercaseCountry}@2020`;
};
